import { create } from 'zustand';
import { persist, subscribeWithSelector } from 'zustand/middleware';
import i18n from 'i18next';


const STORAGE_KEY = 'app_language';

const settingStore = create(
  subscribeWithSelector(
    persist(
      (set, get) => ({
        // 기본값
        language: 'ko',

        setLanguage: (lang) => {
          const current = get().language;
          if (!lang || lang === current) return;

          set({ language: lang });
          window.location.reload(); // api 호출 하기 위해 새로고침
          // i18n 변경은 app.js에서 새로 고침 후 재적용 i18n.changeLanguage(lang);
        },
      }),
      {
        name: STORAGE_KEY, // localStorage key

        /**
         * persist가 저장된 값을 복원할 때 호출됨
         * 여기에서 i18n과 값 맞춰주면 됨
         */
        onRehydrateStorage: () => (state) => {
          const lang = state?.language ?? 'ko';
          if (i18n.language !== lang) {
            i18n.changeLanguage(lang);
          }
        },
      },
    ),
  ),
);

export default settingStore;
